import type { ChatAttachment } from '@prakash-software/shared';
import { apiFetch } from './api';

interface UploadIntent {
  uploadUrl: string;
  fields: Record<string, string>;
  intentToken: string;
}

export async function uploadChatAttachment(
  file: File,
  sessionId: string,
  siteId: string,
): Promise<ChatAttachment> {
  const request = { sessionId, siteId, filename: file.name, mimeType: file.type, byteSize: file.size };
  const intent = await apiFetch<UploadIntent>('/api/uploads/agent/initiate', {
    method: 'POST',
    body: JSON.stringify(request),
  });
  const form = new FormData();
  for (const [key, value] of Object.entries(intent.fields)) form.append(key, value);
  form.append('file', file);
  const uploaded = await fetch(intent.uploadUrl, { method: 'POST', body: form });
  if (!uploaded.ok) throw new Error(`object-upload-${uploaded.status}`);
  const result = await apiFetch<{ attachment: ChatAttachment }>('/api/uploads/agent/complete', {
    method: 'POST',
    body: JSON.stringify({ sessionId, siteId, intentToken: intent.intentToken }),
  });
  return result.attachment;
}
